<div class="dialog-container">
  <div class="page" [ngClass]="{choose: isRestricted()}">
    <span *ngIf="!isRestricted()" class="page-title">Compass Template Manager</span>
    <div *ngIf="!isRestricted()" class="tabs">
      <button mat-button class="dialog-standard-tab" [ngClass]="{selected: tab == 'TRACKABLE_SCALE'}" [disabled]="editing" (click)="tab = 'TRACKABLE_SCALE'">
        Trackable Scales
      </button>
      <button mat-button class="dialog-standard-tab" [ngClass]="{selected: tab == 'QUESTION'}" [disabled]="editing" (click)="tab = 'QUESTION'">
        Assessment Questions
      </button>
      <button mat-button class="dialog-standard-tab" [ngClass]="{selected: tab == 'SUMMARY_SCALE'}" [disabled]="editing" (click)="tab = 'SUMMARY_SCALE'">
        Summary Scales
      </button>
    </div>
    <div class="page-body">
      <div class="page-body-sidebar standard-listing" *ngVar="getRelevantAutocompletes() as autocompletes">
        <input #filter class="header" type="text" [placeholder]="getFilterPlaceholder()" [disabled]="editing" [(ngModel)]="filterText" />
        <div *ngIf="isLoading()" class="listings">
          <listing-component *ngFor="let listing of [1,2,3,4,5,6,7,8,9]" [skeleton]="true" [hasAvatar]="false"
            [hasDesc]="false" [longTitleSkeleton]="true"></listing-component>
        </div>
        <div *ngIf="!isLoading() && autocompletes.length == 0" class="empty-state">
          Nothing to show
        </div>
        <div *ngIf="!isLoading() && autocompletes.length > 0" class="listings">
          <listing-component *ngFor="let listing of autocompletes" [title]="listing.getListingName()" [hasAvatar]="false"
            [disabled]="editing" [selected]="isSelected(listing)" (click)="select(listing)"></listing-component>
        </div>
        <button mat-icon-button *ngIf="!isLoading()" class="circle-button" [title]="getAddTitle()" [disabled]="editing" (click)="add()">
          <img src="assets/content-icon/ic-04.svg" />
        </button>
      </div>
      <div *ngIf="isLoading()" class="page-body-content" [ngSwitch]="tab">
        <div *ngSwitchCase="'TRACKABLE_SCALE'" class="fields skeleton">
          <div class="input-area">
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="double">
              <div class="subheader-line skeleton skeleton-animation"></div>
              <div class="card input-area" *ngFor="let i of [1,2,3]">
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'QUESTION'" class="fields skeleton">
          <div class="input-area">
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="input-container">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="double">
              <div class="subheader-line skeleton skeleton-animation"></div>
              <div class="card input-area" *ngFor="let i of [1,2,3]">
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'SUMMARY_SCALE'" class="fields skeleton">
          <div class="input-area">
            <div class="input-container double">
              <span class="label skeleton-animation"></span>
              <div class="input skeleton-animation"></div>
            </div>
            <div class="double">
              <div class="subheader-line skeleton skeleton-animation"></div>
              <div class="card input-area" *ngFor="let i of [1,2,3]">
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
                <div class="input-container">
                  <span class="label skeleton-animation"></span>
                  <div class="input skeleton-animation"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button mat-button class="text-button" [ngClass]="{secondary: isRestricted()}" disabled>Edit</button>
          <button mat-button *ngIf="isRestricted()" class="text-button" disabled>Choose</button>
        </div>
      </div>
      <div *ngIf="!isLoading() && !selected" class="page-body-content center">
        <div class="empty-title">{{getEmptyStateTitle()}}</div>
        <div class="empty-desc">{{getEmptyStateDesc()}}</div>
      </div>
      <div *ngIf="!isLoading() && selected" class="page-body-content" [ngSwitch]="tab">
        <div class="fields" *ngVar="(!editing || selected.isSaving()) as formDisabled">
          <div *ngSwitchCase="'TRACKABLE_SCALE'" class="input-area">
            <!-- Scale Name -->
            <div class="input-container" *ngVar="selected.name as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Scale Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the trackable scale.', 'Symptom Scale')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="50" placeholder="Symptom Scale" (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="formDisabled || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Scale Type -->
            <div class="input-container" *ngVar="selected.scaleType as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Scale Type</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The type of scale that will be used to calculate the trackable\'s contribution to the compass scale over some interval.  \'Sum\' adds the measurement values over the interval, \'Average\' averages them, and \'Count\' both averages and counts them.', 'Average')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="None" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Scale Ranges -->
            <div class="double">
              <div class="subheader-line" *ngVar="selected.scaleRangesGroup as group"
                [ngClass]="{dirty: !selected.isNew() && group.isDirty(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Scale Ranges</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The scale ranges that will be used to determine the trackable\'s contribution to the compass\'s scale value over some interval.  Each range provides conditions under which it will apply.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button" [disabled]="formDisabled" (click)="selected.addScaleRange(); setShouldScrollToNew()">
                  <img src="assets/content-icon/ic-04.svg" class="icon" />
                </button>
              </div>
              <div *ngIf="selected.scaleRanges.length == 0" class="empty-state"
                [ngClass]="{error: selected.statusField.getDisplayedIssue()}">
                {{selected.statusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let range of selected.scaleRanges; index as i"
                [ngClass]="{dirty: range.isDirty() || (selected.isDirty() && range.isNew), invalid: range.hasVisibleIssue()}">
                <button mat-button class="text-button corner-button" [disabled]="formDisabled"
                  (click)="selected.removeScaleRange(range.id); selected.statusField.touch();">
                  <img src="assets/content-icon/ic-05.svg" class="icon" />
                </button>
                <span class="error-message">{{range.statusField.getDisplayedIssue()}}</span>
                <!-- Range ID -->
                <div class="input-container" *ngVar="translateRangeIndex(i) as rangeId" [title]="rangeId">
                  <div class="label-line">
                    <span class="label">Range ID</span>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'An identifier for the scale range that is unique within the scale.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" [ngModel]="rangeId" disabled />
                </div>
                <!-- Weight -->
                <div class="input-container" *ngVar="range.weight as field"
                  [title]="formDisabled ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Weight</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The value that the scale range will contribute to the compass\'s scale value if its conditions are met.', '10')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10" (blur)="field.touch()"
                    [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Minimum -->
                <div class="input-container" *ngVar="range.minimum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Minimum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive minimum aggregated measurement value over some interval required for the scale range to be applied.', '0')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="0"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Maximum -->
                <div class="input-container" *ngVar="range.maximum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Maximum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The exclusive maximum aggregated measurement value over some interval required for the scale range to be applied.', '20')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="20"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Count Minimum -->
                <div class="input-container" *ngVar="range.countMinimum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty(), hidden: !range.isCount()}">
                  <div class="label-line">
                    <span class="label">Count Minimum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive minimum number of measurements logged over some interval required for the scale range to be applied.', '0')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="0"
                    (blur)="range.touchCountMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Count Maximum -->
                <div class="input-container" *ngVar="range.countMaximum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty(), hidden: !range.isCount()}">
                  <div class="label-line">
                    <span class="label">Count Maximum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive maximum number of measurements logged over some interval required for the scale range to be applied.', '1')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="1"
                    (blur)="range.touchCountMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'QUESTION'" class="input-area">
            <!-- Question Name -->
            <div class="input-container double" *ngVar="selected.name as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Question Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the assessment question.', 'General Question 1')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="50" placeholder="General Question 1" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Question -->
            <div class="input-container double" *ngVar="selected.questionGroup.question as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Question</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The question text that will show up in the assessment.', 'How are you feeling?')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" placeholder="How are you feeling?" (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="formDisabled || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Cared For Question -->
            <div class="input-container double" *ngVar="selected.questionGroup.caredForQuestion as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Journaled For Question</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The question text that will show up in the assessment when it is taken for a journaled for user.  Use \'\{\{username\}\}\' to show the user\'s name and \'\{\{logForName\}\}\' to show the journaled for user\'s name.', 'How are you feeling, \{\{logForName\}\}?')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" [placeholder]="'How are you feeling, \{\{logForName\}\}?'" (blur)="field.touch()" [(ngModel)]="field.value"
                [disabled]="formDisabled || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Answer Type -->
            <div class="input-container" *ngVar="selected.questionGroup.answerType as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{double: !selected.questionGroup.isButton(), error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Answer Type</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The type of answer to get for the question.', 'Button')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="Button" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="formDisabled || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Is Multi-Answer -->
            <div class="input-container" *ngVar="selected.questionGroup.multiAnswer as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.getDisplayValue()"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty(), hidden: !selected.questionGroup.isButton()}">
              <div class="label-line">
                <span class="label">Is Multi-Answer</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'Allow the user to select multiple buttons buttons rather than just one.', 'No')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <mat-select class="input select" placeholder="No" (openedChange)="field.openedChange($event)"
                (blur)="field.handleBlur($event)" [(ngModel)]="field.value"
                [disabled]="formDisabled || !field.isEditable()">
                <mat-option *ngFor="let option of field.options.options" [value]="option.value">
                  {{option.displayValue}}
                </mat-option>
              </mat-select>
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Buttons -->
            <div *ngIf="selected.questionGroup.isButton()" class="double">
              <div class="subheader-line" *ngVar="selected.questionGroup.buttonsGroup as group"
                [ngClass]="{dirty: !selected.isNew() && group.isDirty(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Buttons</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The buttons that the user can choose from to answer the question.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button" [disabled]="formDisabled"
                  (click)="selected.questionGroup.addButton(); setShouldScrollToNew()">
                  <img src="assets/content-icon/ic-04.svg" class="icon" />
                </button>
              </div>
              <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let button of selected.questionGroup.buttons; index as i"
                [ngClass]="{dirty: button.isDirty() || (selected.isDirty() && button.isNew), invalid: button.hasVisibleIssue()}">
                <button mat-button class="text-button corner-button" [disabled]="formDisabled"
                  (click)="selected.questionGroup.removeButton(i); selected.questionGroup.statusField.touch();">
                  <img src="assets/content-icon/ic-05.svg" class="icon" />
                </button>
                <span class="error-message">{{button.statusField.getDisplayedIssue()}}</span>
                <!-- Button Text -->
                <div class="input-container double" *ngVar="button.answer as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !button.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Button Text</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The text that shows up in the button.', 'Average')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" placeholder="Average" (blur)="field.touch()" [(ngModel)]="field.value"
                    [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Weights -->
                <div class="double">
                  <div class="subheader-line" *ngVar="button.weightsGroup as group"
                    [ngClass]="{dirty: !button.isNew && group.isDirty(), error: group.hasVisibleIssue()}">
                    <div class="subheader-text">
                      <span class="subheader">Weight</span>
                      <div class="dot"></div>
                      <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                        (click)="showFieldInfo($event, 'A weight to score this question.')">
                        <img src="assets/ic_information_blk.svg" class="icon" />
                      </button>
                    </div>
                    <button mat-button *ngIf="button.weights.length == 0" class="text-button subheader-button" title="Add weight" [disabled]="formDisabled"
                      (click)="button.addWeight(); setShouldScrollToNew()">
                      <img src="assets/content-icon/ic-04.svg" class="icon" />
                    </button>
                  </div>
                  <div *ngIf="button.weights.length == 0" class="empty-state">
                    Nothing to show
                  </div>
                  <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let weight of button.weights; index as i"
                    [ngClass]="{dirty: weight.isDirty() || (button.isDirty() && weight.isNew), invalid: weight.hasVisibleIssue()}">
                    <button mat-button class="text-button corner-button" title="Remove weight" [disabled]="formDisabled"
                      (click)="button.removeWeight(i); button.statusField.touch();">
                      <img src="assets/content-icon/ic-05.svg" class="icon" />
                    </button>
                    <span class="error-message">{{weight.statusField.getDisplayedIssue()}}</span>
                    <div class="input-container double" *ngVar="weight.value as field"
                      [title]="(formDisabled || !field.isEditable()) ? '' : (field.value != null ? field.value : '')"
                      [ngClass]="{error: field.getDisplayedIssue(), dirty: !weight.isNew && field.isDirty()}">
                      <div class="label-line">
                        <span class="label">Weight</span>
                        <div class="dirty-dot"></div>
                        <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                          (click)="showFieldInfo($event, 'The value that this this button will contribute if it is selected by the user.', '10')">
                          <img src="assets/ic_information_blk.svg" class="icon" />
                        </button>
                      </div>
                      <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="10" (blur)="field.touch()"
                        [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                      <span class="error-message">{{field.getDisplayedIssue()}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="selected.questionGroup.buttons.length == 0 || selected.questionGroup.statusField.getDisplayedIssue()"
                class="empty-state" [ngClass]="{error: selected.questionGroup.statusField.getDisplayedIssue()}">
                {{selected.questionGroup.statusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'SUMMARY_SCALE'" class="input-area">
            <!-- Scale Name -->
            <div class="input-container double" *ngVar="selected.name as field"
              [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
              [ngClass]="{error: field.getDisplayedIssue(), dirty: !selected.isNew() && field.isDirty()}">
              <div class="label-line">
                <span class="label">Scale Name</span>
                <div class="dirty-dot"></div>
                <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                  (click)="showFieldInfo($event, 'The name of the summary scale.', 'Standard Summary Scale')">
                  <img src="assets/ic_information_blk.svg" class="icon" />
                </button>
              </div>
              <input type="text" class="input" maxlength="50" placeholder="Standard Summary Scale" (blur)="field.touch()"
                [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
              <span class="error-message">{{field.getDisplayedIssue()}}</span>
            </div>
            <!-- Scale Ranges -->
            <div class="double">
              <div class="subheader-line" *ngVar="selected.scaleRangesGroup as group"
                [ngClass]="{dirty: !selected.isNew() && group.isDirty(), error: group.hasVisibleIssue()}">
                <div class="subheader-text">
                  <span class="subheader">Scale Ranges</span>
                  <div class="dot"></div>
                  <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                    (click)="showFieldInfo($event, 'The scale ranges that will be used to determine the compass\'s score text over some interval.  Each range provides conditions under which it will apply.')">
                    <img src="assets/ic_information_blk.svg" class="icon" />
                  </button>
                </div>
                <button mat-button class="text-button subheader-button" [disabled]="formDisabled"
                  (click)="selected.addScaleRange(); setShouldScrollToNew()">
                  <img src="assets/content-icon/ic-04.svg" class="icon" />
                </button>
              </div>
              <div *ngIf="selected.scaleRanges.length == 0" class="empty-state"
                [ngClass]="{error: selected.statusField.getDisplayedIssue()}">
                {{selected.statusField.getDisplayedIssue() || 'Nothing to show'}}
              </div>
              <div (ngInit)="scrollToNew($event)" class="card input-area" *ngFor="let range of selected.scaleRanges; index as i"
                [ngClass]="{dirty: range.isDirty() || (selected.isDirty() && range.isNew), invalid: range.hasVisibleIssue()}">
                <button mat-button class="text-button corner-button" [disabled]="formDisabled"
                  (click)="selected.removeScaleRange(range.id); selected.statusField.touch();">
                  <img src="assets/content-icon/ic-05.svg" class="icon" />
                </button>
                <span class="error-message">{{range.statusField.getDisplayedIssue()}}</span>
                <!-- Range ID -->
                <div class="input-container" *ngVar="translateRangeIndex(i) as rangeId" [title]="rangeId">
                  <div class="label-line">
                    <span class="label">Range ID</span>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'An identifier for the scale range that is unique within the scale.')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" class="input" [ngModel]="rangeId" disabled />
                </div>
                <!-- Text -->
                <div class="input-container" *ngVar="range.name as field" [title]="formDisabled ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Text</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The text that will show up in the compass\'s score card if the scale range\'s conditions are met.', 'Average')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input type="text" maxlength="20" class="input" placeholder="Average" (blur)="field.touch()" [(ngModel)]="field.value"
                    [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Minimum -->
                <div class="input-container" *ngVar="range.minimum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Minimum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The inclusive minimum aggregated measurement value over some interval required for the scale range to be applied.', '3')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="3"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
                <!-- Maximum -->
                <div class="input-container" *ngVar="range.maximum as field"
                  [title]="(formDisabled || !field.isEditable()) ? '' : field.value"
                  [ngClass]="{error: field.getDisplayedIssue(), dirty: !range.isNew && field.isDirty()}">
                  <div class="label-line">
                    <span class="label">Maximum</span>
                    <div class="dirty-dot"></div>
                    <button mat-button class="text-button label-info-button" tabindex="-1" title="Info"
                      (click)="showFieldInfo($event, 'The exclusive maximum aggregated measurement value over some interval required for the scale range to be applied.', '7')">
                      <img src="assets/ic_information_blk.svg" class="icon" />
                    </button>
                  </div>
                  <input numberInput [int]="field.isInt()" type="text" class="input" placeholder="7"
                    (blur)="range.touchMinMax(field)" [(ngModel)]="field.value" [disabled]="formDisabled || !field.isEditable()" />
                  <span class="error-message">{{field.getDisplayedIssue()}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <mat-progress-spinner *ngIf="selected.isSaving()" class="spinner" color="primary" mode="indeterminate" diameter="21">
          </mat-progress-spinner>
          <div *ngIf="editing">
            <button mat-button class="text-button secondary" [disabled]="selected.isSaving()" (click)="edit(false)">Cancel</button>
            <button mat-button *ngIf="!selected.isNew()" class="text-button secondary" [disabled]="!selected.deleteEnabled()" (click)="delete(selected)">Delete</button>
            <button mat-button class="text-button" [disabled]="!selected.saveEnabled()" (click)="save(selected)">{{selected.id == null ? 'Create' : 'Save'}}</button>
          </div>
          <div *ngIf="!editing">
            <button mat-button class="text-button" [ngClass]="{secondary: isRestricted()}" (click)="edit()">Edit</button>
            <button mat-button *ngIf="isRestricted()" class="text-button" (click)="choose(selected)">Choose</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="backdrop" [ngClass]="{showing: fieldInfoShowing}" (click)="hideFieldInfo()">
  <div #fieldInfo class="popover" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoPosition"
    (click)="$event.stopPropagation()">
    <div class="popover-content">
      <div class="text"></div>
      <div class="subheader">Example</div>
      <div class="text"></div>
    </div>
  </div>
  <div class="popover-arrow" [ngClass]="{showing: fieldInfoShowing}" [style]="fieldInfoArrowPosition"></div>
</div>